import { HiInbox, HiUser, HiCurrencyEuro, HiCog, HiMenu, HiX, HiDocumentText } from "react-icons/hi";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const menuItems = [
    { path: '/', icon: HiUser, label: 'Amicalistes', description: 'Gérer les membres' },
    { path: '/stock', icon: HiInbox, label: 'Produits', description: 'Stock & inventaire' },
    { path: '/budget', icon: HiCurrencyEuro, label: 'Budgets', description: 'Suivi financier' },
    { path: '/invoices', icon: HiDocumentText, label: 'Factures', description: 'Gestion des factures' },
    { path: '/machine', icon: HiCog, label: 'Machine', description: 'Distributeur' },
];

export function Component() {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
            if (window.innerWidth >= 768) {
                setIsOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Fermer le menu lors du changement de page sur mobile
    useEffect(() => {
        if (isMobile) {
            setIsOpen(false);
        }
    }, [location.pathname, isMobile]);

    return (
        <>
            {/* Mobile Header Bar */}
            {isMobile && (
                <div className="fixed top-0 left-0 right-0 z-40 bg-slate-900 text-white px-4 py-3 flex items-center justify-between shadow-lg">
                    <a href="/" className="flex items-center gap-3">
                        <img 
                            src="/logo192.png" 
                            alt="Logo" 
                            className="w-10 h-10 rounded-lg"
                        />
                        <span className="font-bold text-lg">Amicale SP</span>
                    </a>
                    <button 
                        onClick={() => setIsOpen(!isOpen)}
                        className="p-2 rounded-lg hover:bg-slate-700 transition-colors"
                    >
                        {isOpen ? <HiX className="w-6 h-6" /> : <HiMenu className="w-6 h-6" />}
                    </button>
                </div>
            )}

            {/* Overlay for mobile */}
            {isMobile && isOpen && (
                <div 
                    className="fixed inset-0 bg-black/50 z-40 backdrop-blur-sm"
                    onClick={() => setIsOpen(false)}
                ></div>
            )}

            {/* Sidebar */}
            <aside className={`
                ${isMobile 
                    ? `fixed top-0 left-0 h-full z-50 transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'}`
                    : 'relative'
                }
                w-72 min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 text-white flex flex-col shadow-2xl
            `}>
            {/* Logo Section */}
            <div className="p-6 border-b border-slate-700/50">
                <a href="/" className="flex items-center gap-4 group">
                    <div className="relative">
                        <div className="absolute inset-0 bg-indigo-500 rounded-xl blur-lg opacity-50 group-hover:opacity-75 transition-opacity"></div>
                        <img 
                            src="/logo192.png" 
                            alt="Logo Amicale" 
                            className="relative w-14 h-14 rounded-xl object-cover ring-2 ring-white/20"
                        />
                    </div>
                    <div>
                        <h1 className="font-bold text-xl bg-gradient-to-r from-white to-indigo-200 bg-clip-text text-transparent">
                            Amicale SP
                        </h1>
                        <p className="text-xs text-slate-400">Gestion & Suivi</p>
                    </div>
                </a>
            </div>

            {/* Navigation */}
            <nav className="flex-1 p-4 space-y-2">
                <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider px-4 mb-4">
                    Navigation
                </p>
                {menuItems.map((item) => {
                    const isActive = location.pathname === item.path;
                    const Icon = item.icon;
                    
                    return (
                        <a
                            key={item.path}
                            href={item.path}
                            className={`flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-300 group ${
                                isActive 
                                    ? 'bg-gradient-to-r from-indigo-600 to-purple-600 shadow-lg shadow-indigo-500/30' 
                                    : 'hover:bg-slate-700/50'
                            }`}
                        >
                            <div className={`p-2 rounded-lg transition-all ${
                                isActive 
                                    ? 'bg-white/20' 
                                    : 'bg-slate-700 group-hover:bg-indigo-600/50'
                            }`}>
                                <Icon className="w-5 h-5" />
                            </div>
                            <div>
                                <p className={`font-medium ${
                                    isActive ? 'text-white' : 'text-slate-200'
                                }`}>
                                    {item.label}
                                </p>
                                <p className={`text-xs ${
                                    isActive ? 'text-indigo-200' : 'text-slate-500'
                                }`}>
                                    {item.description}
                                </p>
                            </div>
                            {isActive && (
                                <div className="ml-auto w-1.5 h-8 bg-white rounded-full"></div>
                            )}
                        </a>
                    );
                })}
            </nav>

            {/* Footer */}
            <div className="p-4 border-t border-slate-700/50">
                <div className="px-4 py-3 rounded-xl bg-gradient-to-r from-indigo-600/20 to-purple-600/20 border border-indigo-500/20">
                    <p className="text-xs text-slate-400">Version 2.0</p>
                    <p className="text-sm font-medium text-indigo-300">Amicale des Sapeurs-Pompiers</p>
                </div>
            </div>
        </aside>
        </>
    );
}
